// src/utils/loadDynamicDashboards.tsx
import React from "react";
import Icon from "@mui/material/Icon";
import { READ, DASHBOARD_FEATURE } from "requests/constants";
import { post } from "../requests";
import ApplicationList from "../pages/applications/List";
import MetabaseViewerWrapper from "../pages/dashboard/MetabaseViewerWrapper";

export interface DynamicRoute {
  type: "single";
  name: string;
  key: string;
  icon: React.ReactElement;
  route: string;
  permission?: { action: string; resource: string };
  feature: string;
}

interface DashboardResponse {
  dashboardId: number;
  name: string;
  permission?: { action: string; resource: string };
}

export async function loadDynamicDashboardRoutes(): Promise<DynamicRoute[]> {
  try {
    const roleName = localStorage.getItem("userRole") || "";
    const isAdmin = roleName.toLowerCase() === "admin";

    if (!isAdmin) {
      return [];
    }

    const response = await post("get-admin-dashboard-urls", { filters: {} });
    const data: DashboardResponse[] = Array.isArray(response) ? response : [];
    return data.map((d) => ({
      type: "single",
      id: d.dashboardId,
      name: d.name,
      key: `dashboard-${d.dashboardId}`,
      icon: <Icon fontSize="medium">insights</Icon>,
      route: `/metabase/dashboard/:id`,
      href: `#/metabase/dashboard/${d.dashboardId}`,
      permission: d.permission,
      feature: DASHBOARD_FEATURE,
      component: <MetabaseViewerWrapper />,
    }));
  } catch (e) {
    console.error("Failed to load admin dashboards:", e);
    return [];
  }
}

export async function loadSyndicatorDashboardRoutes(userId: number): Promise<DynamicRoute[]> {
  try {
    const response = await post("get-syndicator-own-dashboard-urls", { userId });
    const data: DashboardResponse[] = Array.isArray(response)
      ? response
      : response?.dashboards || [];
    return data.map((d) => ({
      type: "single",
      id: d.dashboardId,
      name: d.name,
      key: `syndicator-dashboard-${d.dashboardId}`,
      icon: <Icon fontSize="medium">insights</Icon>,
      route: `/metabase/dashboard/:id`,
      href: `#/metabase/dashboard/${d.dashboardId}`,
      permission: d.permission,
      feature: DASHBOARD_FEATURE,
      component: <MetabaseViewerWrapper />,
    }));
  } catch (e) {
    console.error("Failed to load syndicator dashboards:", e);
    return [];
  }
}
